<section class="main-section">
    <section class="border-0 h-100 w-100 bg-transparent">
        <div class="text-center">

            <div class="card h-100 shadow">
                <div class="card-body">

                    <h2 class="mb-3 d-none d-lg-block">{{ 'Predmety' | translate }}</h2>

                    <app-zapisny-list-selector></app-zapisny-list-selector>

                    <app-progress-spinner *ngIf="spinner"></app-progress-spinner>

                    @if (config?.elZapisAkRok && hasZapisnyListForElZapisAkRok) {
                        <div class="text-start ms-3 mb-3">
                            <button type="button" class="btn btn-link p-0" (click)="openElektronickyZapis()">
                                <span i18n>Dokončiť Môj zápis ak. rok</span> {{config.elZapisAkRok}}
                            </button>
                        </div>
                    }

                    <div class="row align-middle mb-3">
                        <div class="col-6 text-start">
                            <section *ngIf="config && config.zapis" class="ms-2 align-self-auto">

                                <button class="mt-1 p-3 pt-4 pb-4" mat-raised-button (click)="openStudijnyPlan()">
                                    <mat-icon class="me-2">add_circle_outline</mat-icon>
                                    <span i18n>Zápis predmetov</span>
                                </button>

                            </section>
                        </div>
                        <div class="col-6">
                            <app-semester-selector></app-semester-selector>
                        </div>
                    </div>

                    <div class="w-100" *ngIf="znamky">

                        <table class="table w-100">
                            <tbody>

                            <ng-container *ngFor="let s of sections; let i = index;" class="w-100">
                                <ng-container
                                    *ngIf="s.castSpKod != 'SS' || s.typVyucbyKod != 'B' || s.predmety.length > 0">
                                    <tr class="w-100" *ngIf="i == 0 || sections[i].castSp != sections[i-1].castSp">
                                        <td class="border-0" colspan="7">
                                            <div class="studijna-cast d-flex justify-content-between p-2 pb-0">
                                                <div>{{ s.castSp }}</div>
                                                <div class="kredity" *ngIf="!s.typVyucby"><span
                                                    i18n>Kredity</span>: {{ s.kredit }}/{{ s.kreditZiskany }}
                                                </div>
                                            </div>
                                        </td>
                                    </tr>
                                    <tr class="w-100" *ngIf="s.typVyucby">
                                        <td colspan="7">
                                            <div class="typ-vyucby d-flex justify-content-between ps-3 pe-3 ps-sm-0">
                                                <div class="ms-0 ms-sm-4">{{ s.typVyucby }}</div>
                                                <div class="kredity"><span i18n>Kredity</span>: {{ s.kredit }}
                                                    /{{ s.kreditZiskany }}
                                                </div>
                                            </div>
                                        </td>
                                    </tr>
                                    <tr class="w-100">
                                        <td colspan="7">
                                            <app-znamky-tabulka [data]="s.predmety"></app-znamky-tabulka>
                                        </td>
                                    </tr>
                                </ng-container>
                            </ng-container>

                            </tbody>
                        </table>

                    </div>

                </div>
            </div>
        </div>

    </section>
</section>
